import React from 'react';

export class Icon extends React.Component {
	render() {
		return (
			<i className={`icon ${this.props.className || ''} ${this.props.icon}`} />
		);
	}
}
